
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { default as __Next_Translate_old_getServerSideProps__1a06c87ef34__ } from '@utils/serverSide/getBasicServerSideProps';
import VogelActuFiveInfosPage from '@screens/VogelActu/FiveInfos';
import withRestrictions from '@utils/hoc/withRestrictions';
export {} from '@utils/serverSide/getBasicServerSideProps';
export default withRestrictions(VogelActuFiveInfosPage);

    async function __Next_Translate__getServerSideProps__1a06c87ef34__(ctx) {
      const res = await __Next_Translate_old_getServerSideProps__1a06c87ef34__(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/vogel-actu/livv-newsflash',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87ef34__ as getServerSideProps }
  